import axios from 'axios';
import { loginreq, getReq,postRed } from './axiosFun';

// 登录接口
export const login = (user) => { return loginreq("POST", "/log/login", user) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 首页
 **/
//单量对比
export const dataComparison = (userId) => { return getReq("get", "/home/dataComparison",{}) };
//日单量
export const dayAmount = (params) => { return postRed("post", "/homePage/selectNumberByClock",{}) };
//首页查看单量
export const dealCount = (date) => { return postRed("post", "/homePage/pageNumber",{}) };
//查看当前账号下年检车辆
export const grade = (userId) => { return getReq("get", "/home/getGrade",{}) };





// WEBPACK FOOTER //
// ./src/api/homeMG.js